export class SoMeUser {
  public Id!: string;
  public FirstName!: string;
  public LastName!: string;
  public Email!: string;
}
